import clients from "../../../assets/icons/TotalClients.svg";
import campaigns from "../../../assets/icons/SidebarCampaignsIcon.svg";

const StatsCard = () => {
  const cardData = [
    { title: "Total Users", value: 2000, icon: clients, bgColor: "#FFD2DD" },
    { title: "Active Users", value: 1500, icon: clients, bgColor: "#F0F0F0" },
    { title: "Active Campaigns", value: 50, icon: campaigns, bgColor: "#D2EBFF" },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-5">
      {cardData.map((card, idx) => (
        <div key={idx} className="flex">
          <div
            className="
              w-full h-full
              rounded-xl
              shadow
              p-4
              min-h-[120px]
              bg-white dark:bg-slate-800
              border border-transparent
              dark:border-slate-700
            "
          >
            <div className="flex items-center justify-between h-full">
              {/* LEFT TEXT */}
              <div className="text-left">
                <h6
                  className="
                    mb-1
                    text-base
                    font-medium
                    text-slate-700 dark:text-slate-300
                  "
                >
                  {card.title}
                </h6>
                <h3
                  className="
                    text-[32px]
                    font-bold
                    leading-none
                    text-slate-900 dark:text-white
                  "
                >
                  {card.value}
                </h3>
              </div>

              {/* RIGHT ICON */}
              <div
                className="
                  flex items-center justify-center
                  rounded-full
                  w-[55px] h-[55px]
                  shrink-0
                "
                style={{ backgroundColor: card.bgColor }}
              >
                <img
                  src={card.icon}
                  alt={card.title}
                  className="w-1/2 h-1/2 object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsCard;